import { combineReducers } from 'redux'
import selected from './get-one'
import all from './get-all'
import newOne from './new'
import editOne from './edit'
import deleteOne from './delete'

const reducer = combineReducers({
  selected,
  all,
  newOne,
  editOne,
  deleteOne,
})

export default reducer
